const esc = (s) => String(s ?? '')
  .replace(/&/g, '&amp;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;');

const wrap = (subtitle, body) => `<!DOCTYPE html>
<html lang="en" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width,initial-scale=1.0">
<meta http-equiv="X-UA-Compatible" content="IE=edge">
<!--[if mso]>
<noscript><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml></noscript>
<![endif]-->
</head>
<body style="margin:0;padding:0;background-color:#f0f0f0;font-family:Arial,Helvetica,sans-serif;">
<table width="100%" cellpadding="0" cellspacing="0" border="0" bgcolor="#f0f0f0">
<tr><td align="center" style="padding:30px 10px;">

  <table width="600" cellpadding="0" cellspacing="0" border="0" style="max-width:600px;width:100%;">

    <!-- HEADER -->
    <tr>
      <td align="center" bgcolor="#c0392b" style="padding:28px 40px;">
        <p style="margin:0 0 6px 0;color:#f5c6c6;font-size:11px;font-family:Arial,Helvetica,sans-serif;letter-spacing:3px;text-transform:uppercase;">AkdmeTech</p>
        <h1 style="margin:0;color:#ffffff;font-size:22px;font-weight:bold;font-family:Arial,Helvetica,sans-serif;">${esc(subtitle)}</h1>
      </td>
    </tr>

    <!-- BODY -->
    <tr>
      <td bgcolor="#ffffff" style="padding:36px 40px;font-family:Arial,Helvetica,sans-serif;">
        ${body}

        <!-- CONTACT DIVIDER -->
        <table width="100%" cellpadding="0" cellspacing="0" border="0" style="margin-top:32px;border-top:1px solid #eeeeee;">
          <tr>
            <td style="padding-top:20px;">
              <p style="margin:0;color:#888888;font-size:13px;font-family:Arial,Helvetica,sans-serif;line-height:1.6;">
                Questions? Call <a href="tel:+16177518481" style="color:#c0392b;text-decoration:none;font-weight:bold;">+1 (617) 751-8481</a>
                &nbsp;or email&nbsp;
                <a href="mailto:helpdesk@akdmetech.com" style="color:#c0392b;text-decoration:none;">helpdesk@akdmetech.com</a>
              </p>
            </td>
          </tr>
        </table>
      </td>
    </tr>

    <!-- FOOTER -->
    <tr>
      <td align="center" bgcolor="#2c2c2c" style="padding:20px 40px;">
        <p style="margin:0;color:#888888;font-size:11px;font-family:Arial,Helvetica,sans-serif;line-height:1.8;">
          &copy; 2026 AkdmeTech &nbsp;&middot;&nbsp; 102 River Street, Lynn, MA 01905<br>
          <a href="https://akdmeshop.com" style="color:#c0392b;text-decoration:none;">akdmeshop.com</a>
        </p>
      </td>
    </tr>

  </table>

</td></tr>
</table>
</body>
</html>`;

const refBox = (label, value) => `
<table width="100%" cellpadding="0" cellspacing="0" border="0" style="margin-bottom:28px;">
  <tr>
    <td align="center" bgcolor="#fff5f5" style="padding:20px;border:2px solid #c0392b;">
      <p style="margin:0 0 4px 0;color:#888888;font-size:10px;font-family:Arial,Helvetica,sans-serif;letter-spacing:2px;text-transform:uppercase;">${esc(label)}</p>
      <p style="margin:0;color:#c0392b;font-size:26px;font-weight:bold;font-family:Arial,Helvetica,sans-serif;letter-spacing:2px;">${esc(value)}</p>
    </td>
  </tr>
</table>`;

const detailsTable = (rows) => `
<table width="100%" cellpadding="0" cellspacing="0" border="0" style="margin-bottom:24px;border:1px solid #dddddd;">
  ${rows.map(([label, value], i) => `
  <tr>
    <td width="35%" bgcolor="#f7f7f7" style="padding:11px 14px;${i < rows.length - 1 ? 'border-bottom:1px solid #dddddd;' : ''}vertical-align:top;">
      <p style="margin:0;color:#888888;font-size:11px;font-family:Arial,Helvetica,sans-serif;text-transform:uppercase;letter-spacing:1px;">${esc(label)}</p>
    </td>
    <td style="padding:11px 14px;${i < rows.length - 1 ? 'border-bottom:1px solid #dddddd;' : ''}vertical-align:top;">
      <p style="margin:0;color:#333333;font-size:14px;font-family:Arial,Helvetica,sans-serif;line-height:1.5;">${esc(value)}</p>
    </td>
  </tr>`).join('')}
</table>`;

const statusBadge = (status) => {
  const colors = {
    Pending:       '#e67e22',
    Processing:    '#2980b9',
    'In Progress': '#2980b9',
    Shipped:       '#8e44ad',
    Delivered:     '#27ae60',
    Completed:     '#27ae60',
    Cancelled:     '#c0392b',
  };
  const bg = colors[status] || '#555555';
  return `<span style="display:inline-block;background-color:${bg};color:#ffffff;padding:5px 14px;font-size:13px;font-weight:bold;font-family:Arial,Helvetica,sans-serif;">${esc(status)}</span>`;
};

const cta = (label, url) => `
<table width="100%" cellpadding="0" cellspacing="0" border="0" style="margin:24px 0 8px;">
  <tr>
    <td align="center">
      <!--[if mso]>
      <v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word"
        href="${url}" style="height:44px;v-text-anchor:middle;width:220px;" arcsize="0%"
        strokecolor="#c0392b" fillcolor="#c0392b">
        <w:anchorlock/>
        <center style="color:#ffffff;font-family:Arial,Helvetica,sans-serif;font-size:14px;font-weight:bold;">${esc(label)}</center>
      </v:roundrect>
      <![endif]-->
      <!--[if !mso]><!-->
      <a href="${url}" style="background-color:#c0392b;color:#ffffff;display:inline-block;font-family:Arial,Helvetica,sans-serif;font-size:14px;font-weight:bold;padding:13px 36px;text-decoration:none;">${esc(label)}</a>
      <!--<![endif]-->
    </td>
  </tr>
</table>`;

const greeting = (name) =>
  `<p style="color:#333333;font-size:16px;font-family:Arial,Helvetica,sans-serif;margin:0 0 6px 0;">Hi <strong>${esc(name)}</strong>,</p>`;

const lead = (text) =>
  `<p style="color:#555555;font-size:15px;font-family:Arial,Helvetica,sans-serif;margin:0 0 24px 0;line-height:1.7;">${esc(text)}</p>`;

// ── Exported templates ─────────────────────────────────────────────────────

export const bookingConfirmationEmail = ({ firstName, refId, service, description, date, time }) => {
  const html = wrap('Booking Confirmed', `
    ${greeting(firstName)}
    ${lead('Your service booking has been received. Our team will review it and contact you shortly to confirm your appointment.')}
    ${refBox('Booking Reference', refId)}
    ${detailsTable([
      ['Service',     service],
      ['Date & Time', `${date} at ${time}`],
      ['Description', description],
    ])}
    ${cta('Track Your Request', 'https://akdmeshop.com/track-repair')}
  `);
  const text = `Hi ${firstName},\n\nYour booking is confirmed!\n\nReference: ${refId}\nService: ${service}\nAppointment: ${date} at ${time}\nDescription: ${description}\n\nTrack: https://akdmeshop.com/track-repair\n\nAkdmeTech`;
  return { html, text };
};

export const orderConfirmationEmail = ({ firstName, orderId, items, total, address }) => {
  const itemRows = items.map((i, idx) => `
  <tr bgcolor="${idx % 2 === 0 ? '#ffffff' : '#f9f9f9'}">
    <td style="padding:10px 14px;border-bottom:1px solid #eeeeee;font-family:Arial,Helvetica,sans-serif;font-size:14px;color:#333333;">${esc(i.name)}</td>
    <td align="center" style="padding:10px 14px;border-bottom:1px solid #eeeeee;font-family:Arial,Helvetica,sans-serif;font-size:14px;color:#555555;">&times;${i.quantity}</td>
    <td align="right" style="padding:10px 14px;border-bottom:1px solid #eeeeee;font-family:Arial,Helvetica,sans-serif;font-size:14px;color:#333333;font-weight:bold;">$${(i.price * i.quantity).toFixed(2)}</td>
  </tr>`).join('');

  const html = wrap('Order Confirmed', `
    ${greeting(firstName)}
    ${lead("Thank you for your order! We've received it and will start processing right away.")}
    ${refBox('Order ID', orderId)}
    <table width="100%" cellpadding="0" cellspacing="0" border="0" style="margin-bottom:20px;border:1px solid #dddddd;">
      <tr bgcolor="#f0f0f0">
        <th align="left" style="padding:10px 14px;font-family:Arial,Helvetica,sans-serif;font-size:11px;color:#888888;text-transform:uppercase;letter-spacing:1px;font-weight:bold;">Item</th>
        <th align="center" style="padding:10px 14px;font-family:Arial,Helvetica,sans-serif;font-size:11px;color:#888888;text-transform:uppercase;letter-spacing:1px;font-weight:bold;">Qty</th>
        <th align="right" style="padding:10px 14px;font-family:Arial,Helvetica,sans-serif;font-size:11px;color:#888888;text-transform:uppercase;letter-spacing:1px;font-weight:bold;">Price</th>
      </tr>
      ${itemRows}
      <tr bgcolor="#fff5f5">
        <td colspan="2" style="padding:13px 14px;font-family:Arial,Helvetica,sans-serif;font-size:15px;color:#333333;font-weight:bold;">Total</td>
        <td align="right" style="padding:13px 14px;font-family:Arial,Helvetica,sans-serif;font-size:18px;color:#c0392b;font-weight:bold;">$${Number(total).toFixed(2)}</td>
      </tr>
    </table>
    <p style="margin:0 0 4px 0;color:#888888;font-size:11px;font-family:Arial,Helvetica,sans-serif;text-transform:uppercase;letter-spacing:1px;">Shipping Address</p>
    <p style="margin:0 0 24px 0;color:#333333;font-size:14px;font-family:Arial,Helvetica,sans-serif;line-height:1.5;">${esc(address)}</p>
  `);
  const itemText = items.map(i => `  - ${i.name} x${i.quantity} — $${(i.price * i.quantity).toFixed(2)}`).join('\n');
  const text = `Hi ${firstName},\n\nThank you for your order!\n\nOrder: ${orderId}\n\n${itemText}\n\nTotal: $${Number(total).toFixed(2)}\nShipping: ${address}\n\nAkdmeTech`;
  return { html, text };
};

export const orderStatusEmail = ({ firstName, orderId, status, items, total }) => {
  const itemRows = items.map((i, idx) => `
  <tr bgcolor="${idx % 2 === 0 ? '#ffffff' : '#f9f9f9'}">
    <td style="padding:10px 14px;border-bottom:1px solid #eeeeee;font-family:Arial,Helvetica,sans-serif;font-size:14px;color:#333333;">${esc(i.name)}</td>
    <td align="center" style="padding:10px 14px;border-bottom:1px solid #eeeeee;font-family:Arial,Helvetica,sans-serif;font-size:14px;color:#555555;">&times;${i.quantity}</td>
    <td align="right" style="padding:10px 14px;border-bottom:1px solid #eeeeee;font-family:Arial,Helvetica,sans-serif;font-size:14px;color:#333333;font-weight:bold;">$${(i.price * i.quantity).toFixed(2)}</td>
  </tr>`).join('');

  const html = wrap('Order Status Update', `
    ${greeting(firstName)}
    ${lead('Your order status has been updated.')}
    <p style="margin:0 0 20px 0;color:#555555;font-size:14px;font-family:Arial,Helvetica,sans-serif;">
      Order <strong style="color:#333333;">${esc(orderId)}</strong> is now &nbsp;${statusBadge(status)}
    </p>
    <table width="100%" cellpadding="0" cellspacing="0" border="0" style="margin-bottom:16px;border:1px solid #dddddd;">
      <tr bgcolor="#f0f0f0">
        <th align="left" style="padding:10px 14px;font-family:Arial,Helvetica,sans-serif;font-size:11px;color:#888888;text-transform:uppercase;letter-spacing:1px;font-weight:bold;">Item</th>
        <th align="center" style="padding:10px 14px;font-family:Arial,Helvetica,sans-serif;font-size:11px;color:#888888;text-transform:uppercase;letter-spacing:1px;font-weight:bold;">Qty</th>
        <th align="right" style="padding:10px 14px;font-family:Arial,Helvetica,sans-serif;font-size:11px;color:#888888;text-transform:uppercase;letter-spacing:1px;font-weight:bold;">Price</th>
      </tr>
      ${itemRows}
      <tr bgcolor="#fff5f5">
        <td colspan="2" style="padding:13px 14px;font-family:Arial,Helvetica,sans-serif;font-size:15px;color:#333333;font-weight:bold;">Total</td>
        <td align="right" style="padding:13px 14px;font-family:Arial,Helvetica,sans-serif;font-size:18px;color:#c0392b;font-weight:bold;">$${Number(total).toFixed(2)}</td>
      </tr>
    </table>
  `);
  const itemText = items.map(i => `  - ${i.name} x${i.quantity}`).join('\n');
  const text = `Hi ${firstName},\n\nOrder ${orderId} status: ${status}\n\n${itemText}\nTotal: $${Number(total).toFixed(2)}\n\nAkdmeTech`;
  return { html, text };
};

export const productRequestEmail = ({ firstName, refId, category, brand, model, quantity, budget, specs, notes }) => {
  const specRows = Object.entries(specs || {})
    .filter(([, v]) => v)
    .map(([k, v]) => [k.replace(/([A-Z])/g, ' $1').trim(), v]);

  const allRows = [
    ['Category',  category],
    ['Brand',     brand],
    ['Model',     model],
    ['Quantity',  quantity],
    ['Budget',    budget],
    ...specRows,
    ...(notes ? [['Additional Notes', notes]] : []),
  ].filter(([, v]) => v);

  const html = wrap('Product Request Received', `
    ${greeting(firstName)}
    ${lead('Thank you for your product request! Our team will review your requirements and get back to you with availability and pricing within 1–2 business days.')}
    ${refBox('Request Reference', refId)}
    ${detailsTable(allRows)}
    ${cta('Contact Us', 'https://akdmeshop.com/contact')}
  `);
  const specText = allRows.map(([k, v]) => `  ${k}: ${v}`).join('\n');
  const text = `Hi ${firstName},\n\nThank you for your product request!\n\nReference: ${refId}\n\n${specText}\n\nWe will contact you shortly.\n\nAkdmeTech`;
  return { html, text };
};

export const quoteEmail = ({ firstName, refId, productName, category, brand, model, quantity, quotedPrice, acceptUrl }) => {
  const html = wrap('Your Quote is Ready', `
    ${greeting(firstName)}
    ${lead(`Great news! We've reviewed your product request and prepared a quote for you. Please review the details below and click the button to accept and complete your purchase.`)}
    ${refBox('Quote Reference', refId)}
    ${detailsTable([
      ['Product',   productName || `${brand || ''} ${model || ''}`.trim() || category],
      ['Category',  category],
      ['Brand',     brand || '—'],
      ['Model',     model || '—'],
      ['Quantity',  quantity || '1'],
      ['Your Quote', `$${Number(quotedPrice).toFixed(2)}`],
    ].filter(([, v]) => v && v !== '—'))}
    <p style="margin:0 0 8px 0;color:#888888;font-size:12px;font-family:Arial,Helvetica,sans-serif;text-align:center;">
      This quote is valid for 7 days. Click below to accept and complete your payment securely.
    </p>
    ${cta('Accept Quote & Pay Now', acceptUrl)}
    <p style="margin:16px 0 0 0;color:#aaaaaa;font-size:11px;font-family:Arial,Helvetica,sans-serif;text-align:center;">
      If you have questions about this quote, reply to this email or call us at (617) 751-8481.
    </p>
  `);
  const text = `Hi ${firstName},\n\nYour quote is ready!\n\nRef: ${refId}\nProduct: ${productName || `${brand} ${model}`}\nQuantity: ${quantity}\nQuoted Price: $${Number(quotedPrice).toFixed(2)}\n\nAccept & Pay: ${acceptUrl}\n\nQuote valid for 7 days.\n\nAkdmeTech — (617) 751-8481`;
  return { html, text };
};

export const requestStatusEmail = ({ firstName, requestId, status, device, issue, date, time }) => {
  const html = wrap('Service Request Update', `
    ${greeting(firstName)}
    ${lead('Your service request status has been updated.')}
    <p style="margin:0 0 20px 0;color:#555555;font-size:14px;font-family:Arial,Helvetica,sans-serif;">
      Request <strong style="color:#333333;">${esc(requestId)}</strong> is now &nbsp;${statusBadge(status)}
    </p>
    ${detailsTable([
      ['Device',      device],
      ['Issue',       issue],
      ['Appointment', `${date} at ${time}`],
    ])}
    ${cta('Track Your Request', 'https://akdmeshop.com/track-repair')}
  `);
  const text = `Hi ${firstName},\n\nRequest ${requestId} status: ${status}\n\nDevice: ${device}\nIssue: ${issue}\nAppointment: ${date} at ${time}\n\nTrack: https://akdmeshop.com/track-repair\n\nAkdmeTech`;
  return { html, text };
};
